const UPDATE_ASSET_LIST = 'UPDATE_ASSET_LIST';
const UPDATE_CRYPTO_ASSET = 'UPDATE_CRYPTO_ASSET';
const FETCHING_API_ASSETS = 'FETCHING_API_ASSETS';
const FETCHING_API_SUCCESS = 'FETCHING_API_SUCCESS';
const FETCHING_API_FAILURE = 'FETCHING_API_FAILURE';
const NEXT_PAGE = 'NEXT_PAGE';
const PREV_PAGE = 'PREV_PAGE';
const UPDATE_PAGE = 'UPDATE_PAGE';
const FILTER_UPDATE = 'FILTER_UPDATE';
const CURRENCY_UPDATE = 'CURRENCY_UPDATE';
const GET_CURRENT_CURRENCY = 'GET_CURRENT_CURRENCY';

export {
  UPDATE_ASSET_LIST, UPDATE_CRYPTO_ASSET,
  FETCHING_API_ASSETS, FETCHING_API_SUCCESS, FETCHING_API_FAILURE,
  NEXT_PAGE, PREV_PAGE, UPDATE_PAGE,
  FILTER_UPDATE,
  CURRENCY_UPDATE,
  GET_CURRENT_CURRENCY,
};
